import { localAPI } from "../api/local";
import * as blogConstants from "../constants/blogConstants";
// const history = createBrowserHistory();
import history from "../config/history";
import { errorHandler } from "./errorHandler";

export const fetchBlogs = (isPremium) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_LIST_REQUEST,
  });
  try {
    const sortCondition = isPremium ? "sortas=premium" : "sortas=free";
    const data = await localAPI.get(`/api/blogs?${sortCondition}`);
    dispatch({ type: blogConstants.BLOG_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(blogConstants.BLOG_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchBlogsAdmin = (handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_LIST_REQUEST,
  });
  try {
    const data = await localAPI.get("/api/blogs/admin");
    dispatch({ type: blogConstants.BLOG_LIST_SUCCESS, payload: data });
  } catch (error) {
    errorHandler(blogConstants.BLOG_LIST_FAIL, error, false, dispatch);
  }
};

export const fetchBlog = (blogId, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_DETAILS_REQUEST,
  });
  try {
    const data = await localAPI.get(`/api/blogs/${blogId}`);
    await dispatch({
      type: blogConstants.BLOG_DETAILS_SUCCESS,
      payload: data,
    });
    return data.data.blogLink;
  } catch (error) {
    errorHandler(blogConstants.BLOG_DETAILS_FAIL, error, false, dispatch);
  }
};

export const fetchSampleBlog =
  (blogId, handleSignInOpen) => async (dispatch) => {
    dispatch({
      type: blogConstants.BLOG_DETAILS_REQUEST,
    });
    try {
      const data = await localAPI.get(`/api/blogs/sample/${blogId}`);
      await dispatch({
        type: blogConstants.BLOG_DETAILS_SUCCESS,
        payload: data,
      });
      return data.data.blogLink;
    } catch (error) {
      errorHandler(blogConstants.BLOG_DETAILS_FAIL, error, false, dispatch);
    }
  };

export const createBlog = (blog, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_CREATE_REQUEST,
  });
  try {
    const data = await localAPI.post("/api/blogs", blog);
    dispatch({ type: blogConstants.BLOG_CREATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(blogConstants.BLOG_CREATE_FAIL, error, false, dispatch);
  }
};

export const editBlog = (blog) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_UPDATE_REQUEST,
  });
  try {
    const data = await localAPI.patch(`/api/blogs/${blog._id}`, blog);
    dispatch({ type: blogConstants.BLOG_UPDATE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(blogConstants.BLOG_UPDATE_FAIL, error, false, dispatch);
  }
};

export const deleteBlog = (blogId) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_DELETE_REQUEST,
  });
  try {
    const data = await localAPI.delete(`/api/blogs/${blogId}`);
    dispatch({ type: blogConstants.BLOG_DELETE_SUCCESS, payload: data });
    history.go(0);
  } catch (error) {
    errorHandler(blogConstants.BLOG_DELETE_FAIL, error, false, dispatch);
  }
};

export const blogWatched = (blogId, handleSignInOpen) => async (dispatch) => {
  dispatch({
    type: blogConstants.BLOG_WATCHED_REQUEST,
  });
  try {
    await localAPI.post(`/api/blogs/watched/${blogId}`);
    dispatch({ type: blogConstants.BLOG_WATCHED_SUCCESS });
  } catch (error) {
    errorHandler(blogConstants.BLOG_DELETE_FAIL, error, false, dispatch);
  }
};
